export enum DriverCampaignType
{
    None = 0,
    CampaignDriver = 1,
    Xpress50 = 2,
    Xpress50Rider4W = 3,
    Boracay = 4,
    PriorityOrders = 5,
    Xpress2WEV = 6,
    Xpress4WEV = 7,
    AllanGroup = 8,
    LoopPassCampaign = 9,
	NiloGroup = 10,
	Xpress4WEVBataan = 11
}
